import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {equals} from "../../utils"
import {
    ScanDocumentRuleActionTypeDto,
    ScanDocumentRuleDataDto,
    ScanDocumentRuleDetailDto,
    ScanDocumentRuleFieldTypeDto,
} from "../../api/cms";
import {validationStore} from "../ValidationStore";
import {RequestParams} from "../../api/vda";

const emptyObject = {
    name: '',
    contractType: '',
    field: '',
    value: '',
}

class CmsRuleCreateStore {

    get field(): ScanDocumentRuleFieldTypeDto {
        return this._field;
    }

    set field(value: ScanDocumentRuleFieldTypeDto) {
        this._field = value;
    }

    get action(): ScanDocumentRuleActionTypeDto {
        return this._action;
    }

    set action(value: ScanDocumentRuleActionTypeDto) {
        this._action = value;
    }
    get customerId(): string {
        return this._customerId;
    }

    set customerId(value: string) {
        this._customerId = value;
    }

    get saving(): boolean {
        return this._saving;
    }

    set saving(value: boolean) {
        this._saving = value;
    }
    get value(): string {
        return this._value;
    }

    set value(value: string) {
        this._value = value;
    }

    get valid(): boolean {
        return this._valid
    }

    set valid(value: boolean) {
        this._valid = value
    }

    get creating(): boolean {
        return this._creating
    }

    set creating(value: boolean) {
        this._creating = value
    }
    get name(): string {
        return this._name
    }

    set name(value: string) {
        this._name = value
    }
    get id(): string {
        return this._id
    }

    set id(value: string) {
        this._id = value
    }

    get dirty(): boolean {

        const current = this.build()
        return !equals(emptyObject, current)
    }

    private _id: string = ''
    private _creating: boolean = false
    private _saving: boolean = false
    private _valid: boolean = false
    private _name: string = ''
    private _field: ScanDocumentRuleFieldTypeDto = ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE
    private _value: string = ''
    private _action: ScanDocumentRuleActionTypeDto = ScanDocumentRuleActionTypeDto.DESTROY
    private _customerId: string = ''

    constructor() {
        makeAutoObservable(this)
    }

    async create(): Promise<string | void> {
        this.creating = true
        const data = this.build()
        const result = await catchApi(async () =>
            await api.cms.api.createScanDocumentRule(this.customerId, data))
        this.reset()
        this.creating = false
        return result?.data?.id
    }

    async validate() {
        this.valid = false
        const dto = this.build()
        const validationMethod = (data: ScanDocumentRuleDetailDto, params: RequestParams) =>{
            return api.cms.api.validateScanDocumentRule(this.customerId, data, params);
        }
        await validationStore.validate(validationMethod, {data: dto})
        this.valid = Boolean(validationStore.valid)
    }


    public reset() {
        this.name = ''
        this.field = ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE
        this.value = ''
        this.action = ScanDocumentRuleActionTypeDto.DESTROY
    }

    public build(): ScanDocumentRuleDataDto {
        const {
            name,
            field,
            value,
            action,
        } = this
        return {
            action,
            field,
            name,
            value,
        }
    }
}

const cmsRuleCreateStore = new CmsRuleCreateStore()

export {
    cmsRuleCreateStore
}
